import { POST } from '@/utils/axios.js'

export const apiGetExamSessionList = () => POST('/exam/getExamSessionList', {})

export const apiGetExamInfoList = () => POST('/exam/getExamInfoList', {})

//头像上次
export const apiUploadAvatar = (data) => {
    return POST('/exam/uploadAvatar', data, { 'Content-Type': 'multipart/form-data' })
}

export const apiSubmitExamInfo = (data) => POST('/exam/submitExamInfo', data)

export const apiGetExamInfoById = (data) => POST('/exam/getExamInfoById', data)

export const apiEditExamInfo = (data) => POST('/exam/editExamInfo', data)

export const apiCreateOrder = (data) => POST('/exam/createExamRegistrationOrder', data)